<template>
  <component :is="dialogContent" :parent-data="parentData"/>
</template>

<script>
import IncentiveReward from "@/views/applications/salary/IncentiveReward.vue";
import UsualOvertimePay from "@/views/applications/salary/UsualOvertimePay.vue";
import WeekendsOvertimePay from "@/views/applications/salary/WeekendsOvertimePay.vue";
import FullAttendance from "@/views/applications/salary/FullAttendance.vue";
import SickPay from "@/views/applications/salary/SickPay.vue";
import CarAllowance from "@/views/applications/salary/CarAllowance.vue";
import HousingSubsidy from "@/views/applications/salary/HousingSubsidy.vue";
import CleanClothingSubsidy from "@/views/applications/salary/CleanClothingSubsidy.vue";
import StandardSeniorityAward from "@/views/applications/salary/StandardSeniorityAward.vue";
import MealAllowance from "@/views/applications/salary/MealAllowance.vue";
import HolidaysOverTimePay from "@/views/applications/salary/HolidaysOverTimePay.vue";
import RetentionAwards from "@/views/applications/salary/RetentionAwards.vue";

export default {
  name: "SalaryItem",
  inject: ['$fn'],
  components: {
    IncentiveReward,UsualOvertimePay, WeekendsOvertimePay, FullAttendance, SickPay,
    CarAllowance, HousingSubsidy, CleanClothingSubsidy, StandardSeniorityAward, MealAllowance,
    HolidaysOverTimePay,RetentionAwards
  },
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath: false,
        value: 'type',
        label: 'name'
      },
      loading: false,
      securityTempData: {},
      socialSecurityAreaList: [],
    }
  },
  methods: {},
  computed: {
    dialogContent() {
      switch (this.parentData.name) {
        case '在职奖':
          return IncentiveReward;
        case '标准工龄奖':
          return StandardSeniorityAward;
        case '平时加班费':
          return UsualOvertimePay;
        case '周末加班费':
          return WeekendsOvertimePay;
        case '全勤':
          return FullAttendance;
        case '病假工资':
          return SickPay;
        case '车补':
          return CarAllowance;
        case '住宿补贴':
          return HousingSubsidy;
        case '防尘服补贴':
          return CleanClothingSubsidy;
        case '餐补':
          return MealAllowance;
        case '节假日加班费':
          return HolidaysOverTimePay;
        case '留任奖':
          return RetentionAwards;
        default:
          return IncentiveReward;
      }
    },
  },
}
</script>

<style scoped lang="less">

</style>